<template>
    <BasePopup>
        <div
            class="popupModal"
            v-bind:style="{ zIndex: zIndexMapping[ZIndex.TelegramBotPopup] }"
            v-on:click.self="closePopup"
        >
            <div class="popupModal-content" style="text-align: center;">
                <h2>{{ i18n.t('telegram_bot_tutorial_title') }}</h2>
                <p>{{ i18n.t('telegram_bot_tutorial_subtitle') }}</p>
                <img
                    v-bind:src="telegramIntroductionUrl"
                    alt=""
                    style="width: 100%;"
                >
                <button
                    type="button"
                    class="TelegramBot_Popup_Connect button _primary popupModal-btn"
                    v-on:click="handleCta"
                >
                    {{ i18n.t('telegram_bot_tutorial_cta') }}
                </button>
            </div>
        </div>
    </BasePopup>
</template>

<script lang="ts" setup>
    import telegramIntroductionUrl from '@/assets/images/telegramBot/telegramIntroduction.webp';
    import BasePopup from '@/components/common/BasePopup.vue';
    import { ZIndex } from '@/interface/enum';
    import api from '@/libraries/api';
    import { zIndexMapping } from '@/libraries/helpers/zIndexHelper';
    import { i18n } from '@/libraries/i18n';
    import { useRootStore } from '@/stores/rootStore';

    const emit = defineEmits<{
        close: [];
    }>();

    const { setTopScreenToast } = useRootStore();

    function closePopup() {
        emit('close');
    }

    async function handleCta() {
        try {
            const { inviteLink } = await api.generateTelegramLink();
            window.location.href = inviteLink;
        } catch (err) {
            console.error('Failed to generate Telegram invite link', err);
            setTopScreenToast({
                status: 'error',
                messageKey: 'errorMessage_tryAgainLater',
            });
            closePopup();
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/components/popupModal";
</style>
